<!-- @file 地址编辑 -->
<template>
  <form class="plv-iar-address-edit" @submit="handleSave">
    <div class="plv-iar-address-edit-form">
      <!-- S 联系人 -->
      <div class="plv-iar-ae-form-item">
        <label class="plv-iar-ae-form-item-main">
          <div class="plv-iar-ae-form__label">
            <div class="plv-iar-ae-form__label-text">{{ iarTrans('address.nameLabel') }}</div>
          </div>
          <div class="plv-iar-ae-form-item__body">
            <input
              v-model="formData.name"
              class="plv-iar-ae-input"
              type="text"
              :maxlength="32"
              :placeholder="iarTrans('address.namePlaceholder')"
              @focus="handleFocus"
              @blur="handleBlur"
            />
          </div>
        </label>
        <div class="plv-iar-ae-form-item-error" v-if="formError && formError.name">{{ formError.name[0].message }}</div>
      </div>
      <!-- E 联系人 -->
      <!-- S 手机号码 -->
      <div class="plv-iar-ae-form-item">
        <label class="plv-iar-ae-form-item-main">
          <div class="plv-iar-ae-form__label">
            <div class="plv-iar-ae-form__label-text">{{ iarTrans('address.mobileLabel') }}</div>
          </div>
          <div class="plv-iar-ae-form-item__body">
            <input
              v-model="formData.mobile"
              class="plv-iar-ae-input"
              type="text"
              :maxlength="20"
              :placeholder="iarTrans('address.mobilePlaceholder')"
              @focus="handleFocus"
              @blur="handleBlur"
            />
          </div>
        </label>
        <div class="plv-iar-ae-form-item-error" v-if="formError && formError.mobile">{{ formError.mobile[0].message }}</div>
      </div>
      <!-- E 手机号码 -->
      <!-- S 选择地区 -->
      <div class="plv-iar-ae-form-item">
        <label class="plv-iar-ae-form-item-main">
          <div class="plv-iar-ae-form__label">
            <div class="plv-iar-ae-form__label-text">{{ iarTrans('address.areaLabel') }}</div>
          </div>
          <div class="plv-iar-ae-form-item__body" @click="handleAreaClick">
            <div :class="['plv-iar-ae-input', { 'plv-iar-ae-input--placeholder': !formatedAreaStr }]">{{ formatedAreaStr || iarTrans('address.areaPlaceholder') }}</div>
            <i class="plv-iar-ae-right__icon"></i>
          </div>
        </label>
        <div class="plv-iar-ae-form-item-error" v-if="formError && formError.area">{{ formError.area[0].message }}</div>
      </div>
      <!-- E 选择地区 -->
      <!-- S 详细地址 -->
      <div class="plv-iar-ae-form-item">
        <label class="plv-iar-ae-form-item-main">
          <div class="plv-iar-ae-form__label">
            <div class="plv-iar-ae-form__label-text">{{ iarTrans('address.addressLabel') }}</div>
          </div>
          <div class="plv-iar-ae-form-item__body">
            <textarea
              v-model="formData.address"
              class="plv-iar-ae-textarea"
              rows="3"
              :maxlength="132"
              :placeholder="iarTrans('address.addressPlaceholder')"
              @focus="handleFocus"
              @blur="handleBlur"
            >
            </textarea>
          </div>
        </label>
        <div class="plv-iar-ae-form-item-error" v-if="formError && formError.address">{{ formError.address[0].message }}</div>
      </div>
      <!-- E 详细地址 -->
    </div>
    <div class="plv-iar-address-edit-bottom">
      <button type="submit" class="plv-iar-address-edit-save">{{ iarTrans('address.save') }}</button>
    </div>
  </form>
</template>

<script>
import addressEdit from './addressEdit';

export default {
  mixins: [addressEdit]
};
</script>

<style lang="scss">
.plv-iar-address-edit {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  font-size: 14px;

  input, textarea {
    font-size: 14px;
    font-weight: 400;
  }

  .plv-iar-address-edit-form {
    overflow-y: scroll;
    box-sizing: border-box;
    width: 100%;
    flex: 1;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
  }

  input, textarea {
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    color: inherit;

    &::placeholder {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .plv-iar-ae-form-item-main {
    display: flex;
  }

  .plv-iar-ae-form__label {
    flex-shrink: 0;
    width: 92px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .plv-iar-ae-form__label-text {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 52px;
  }

  .plv-iar-ae-form-item__body {
    flex-grow: 1;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    padding: 10px 12px 10px 0;
    border-bottom: 1px solid #E6E6E6;
  }

  .plv-iar-ae-input {
    width: 100%;
    line-height: 32px;
    color: inherit;

    &.plv-iar-ae-input--placeholder {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .plv-iar-ae-textarea {
    width: 100%;
    line-height: 1.5;
  }

  .plv-iar-ae-form-item-error {
    margin-left: 100px;
    margin-top: 4px;
    font-size: 10px;
    color: #FF6363;
  }

  .plv-iar-address-edit-bottom {
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 16px;
    background: #fff;
  }

  .plv-iar-address-edit-save {
    display: block;
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: #fff;
    border: none;
    border-radius: 40px;
    outline: none;
    user-select: none;
    touch-action: manipulation;
    background: #F15D5D;
  }

  .plv-iar-ae-right__icon {
    width: 16px;
    height: 16px;
    display: block;
    flex-shrink: 0;
    margin-left: 4px;
    background: url('./images/right-outlined.svg') no-repeat;
  }
}
</style>
